/** Type keys of the backend's background tasks that begin or finalize a schedule group (#5182). */
export const PLANNING_TASK_TYPE = {
  finalize: 'FINALIZE_SCHEDULEGROUP',
  begin: 'BEGIN_SCHEDULEGROUP',
} as const;

export type PlanningTaskType = (typeof PLANNING_TASK_TYPE)[keyof typeof PLANNING_TASK_TYPE];

/**
 * Safety net while a task runs: a push can be missed before the hub connected or when a
 * logs read failed, and neither triggers a resync on its own (#5182, PR 1785).
 */
export const PLANNING_TASK_POLL_INTERVAL_MS = 30_000;

/** How many of the user's tasks one catch-up request lists at most. */
export const MAX_LISTED_PLANNING_TASKS = 50;
